import { useEffect } from 'react';

const DEFAULT_DESC = 'Christian D Animator — Motion Designer, Animator, Video Editor & Photographer based in Mansfield, TX, serving the Dallas–Fort Worth Metroplex.';
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1676238560626-45d35b63b38f';

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, key, val] = selector.match(/\[([^=]+)="([^"]+)"]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export default function useSeo({ title, description, image, path } = {}) {
  useEffect(() => {
    const baseTitle = 'Christian D Animator — Motion Designer & Video Editor';
    const fullTitle = title ? `${title} · Christian D Animator` : baseTitle;
    const desc = description || DEFAULT_DESC;
    const img = image || DEFAULT_IMAGE;
    const url = `${window.location.origin}${path || window.location.pathname}`;

    document.title = fullTitle;
    setMeta('meta[name="description"]', 'content', desc);
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', desc);
    setMeta('meta[property="og:image"]', 'content', img);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', desc);
    setMeta('meta[name="twitter:image"]', 'content', img);
    setLink('canonical', url);
  }, [title, description, image, path]);
}
